import { updateLoanSubmission } from 'services'
import { confirmWithCheckboxes } from 'utils'

type OutdatedCondition = {
  no: number
  displayNo?: number
  name: string
  hasDocuments?: boolean
}

export function reviewOutdatedConditions(response: any, setLoading: (loading: boolean) => void) {
  const outdatedConditions: OutdatedCondition[] = response?.conditionEvaluation?.outdatedConditions || []
  if (!outdatedConditions.length) return

  setLoading(false)
  return confirmWithCheckboxes(
    <div className="mb-5 text-left text-gray-800">
      <p className="font-semibold">Some existing conditions no longer match the updated borrower information.</p>
      <p className="mt-2 text-sm">Select the conditions to remove. Unselected conditions will be kept.</p>
      {outdatedConditions.some(({ hasDocuments }) => hasDocuments) && (
        <p className="mt-2 text-sm">Conditions with attached documents are kept automatically.</p>
      )}
    </div>,
    outdatedConditions.map((condition) => ({
      key: `condition-${condition.no}`,
      label: `${condition.displayNo || condition.no} - ${condition.name}${
        condition.hasDocuments ? ' (kept: attached documents)' : ''
      }`,
      defaultChecked: false,
      disabled: condition.hasDocuments,
    })),
    {
      title: 'Review outdated conditions',
      titleYes: 'Remove selected',
      titleNo: 'Keep all',
    },
  ).then((result) => {
    if (result === false) return
    const selectedConditions = outdatedConditions.filter(
      (condition) => !condition.hasDocuments && result[`condition-${condition.no}`],
    )
    if (!selectedConditions.length) return

    setLoading(true)
    return updateLoanSubmission({ delete: selectedConditions }).finally(() => setLoading(false))
  })
}
